import { createContext } from "react";

const TimelineContext = createContext();

export default TimelineContext;
